import {ReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {paymentEventsQueryKeys} from '../hooks/usePaymentEvents';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: paymentEventsQueryKeys.all});
    };

    return (
        <Box mx='sm'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
